module.exports = __webpack_public_path__ + "img/icon-zulip.39a6875e.png";